import {createSelector} from '@ngrx/store';
import {AppState} from "../../../shared/state/app.state";
import {RoleState} from "./role.reducer";

export const selectRoles = (state: AppState) => state.roles;

export const selectAllRoles = createSelector(
  selectRoles,
  (state: RoleState) => state.roles
);

export const selectRoleStatus = createSelector(
  selectRoles,
  (state: RoleState) => state.roleStatus
);

export const selectRolePermissionStatus = createSelector(
  selectRoles,
  (state: RoleState) => state.roleStatus
);

export const selectSelectedRole = createSelector(
  selectRoles,
  (state: RoleState) => state.roles.find(x => x.id === state.selectedRole?.id) ?? null
);

export const selectAllRolesIsEmpty = createSelector(
  selectRoles,
  (state: RoleState) => state.roles.length <= 0
);
